import { put, takeLeading } from 'redux-saga/effects';
import voucherCampaignApi from 'api/voucherCampaignApi';
import { apiErrorHandler, showSuccess } from 'utils';
import {
  GET_VOUCHER_LIST,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAILED,

  GET_VOUCHER_DETAIL,
  GET_VOUCHER_DETAIL_SUCCESS,
  GET_VOUCHER_DETAIL_FAILED,

  CREATE_VOUCHER_CAMPAIGN,
  CREATE_VOUCHER_CAMPAIGN_SUCCESS,
  CREATE_VOUCHER_CAMPAIGN_FAILED,

  UPDATE_VOUCHER_CAMPAIGN,
  UPDATE_VOUCHER_CAMPAIGN_SUCCESS,
  UPDATE_VOUCHER_CAMPAIGN_FAILED,

  ADD_CODE_TO_VOUCHER_CAMPAIGN,
  ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS,
  ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED,

  DELETE_VOUCHERS_FROM_CAMPAIGN,
  DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS,
  DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED,

  DELETE_VOUCHER_CAMPAIGN,
  DELETE_VOUCHER_CAMPAIGN_SUCCESS,
  DELETE_VOUCHER_CAMPAIGN_FAILED,
} from './actionTypes';

// LIST
function* getVoucherList({ payload }) {
  try {
    const response = yield voucherCampaignApi.getListVoucherCampaign(payload);
    yield put({
      type: GET_VOUCHER_LIST_SUCCESS,
      payload: response.payload || response,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_VOUCHER_LIST_FAILED,
    });
  }
}

// DETAIL
function* getVoucherDetail({ payload }) {
  try {
    const response = yield voucherCampaignApi.getVoucherCampaignDetail(payload);
    yield put({
      type: GET_VOUCHER_DETAIL_SUCCESS,
      payload: response.payload || response,
    });
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: GET_VOUCHER_DETAIL_FAILED,
    });
  }
}

// CREATE
function* createVoucherCampaign({ payload }) {
  const { values, callback } = payload;
  try {
    const response = yield voucherCampaignApi.addVoucherCampaign(values);
    const campaign = response?.payload || response;
    yield put({
      type: CREATE_VOUCHER_CAMPAIGN_SUCCESS,
    });
    showSuccess('Tạo chiến dịch voucher thành công');
    if (callback) callback(campaign);
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: CREATE_VOUCHER_CAMPAIGN_FAILED,
    });
  }
}

// UPDATE
function* updateVoucherCampaign({ payload }) {
  const { values, callback } = payload;
  try {
    yield voucherCampaignApi.updateVoucherCampaignDetail(values);
    yield put({
      type: UPDATE_VOUCHER_CAMPAIGN_SUCCESS,
    });
    showSuccess('Chỉnh sửa chiến dịch voucher thành công');
    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: UPDATE_VOUCHER_CAMPAIGN_FAILED,
    });
  }
}

// ADD CODE
function* addCodeToVoucherCampaign({ payload }) {
  const { values, callback } = payload;
  try {
    yield voucherCampaignApi.addCodeToVoucherCampaign(values);
    yield put({
      type: ADD_CODE_TO_VOUCHER_CAMPAIGN_SUCCESS,
    });
    showSuccess('Thêm mã voucher thành công');
    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: ADD_CODE_TO_VOUCHER_CAMPAIGN_FAILED,
    });
  }
}

// DELETE VOUCHERS
function* deleteVouchersFromCampaign({ payload }) {
  const { values, callback } = payload;
  try {
    yield voucherCampaignApi.deleteVouchersFromCampaign(values);
    yield put({
      type: DELETE_VOUCHERS_FROM_CAMPAIGN_SUCCESS,
    });
    showSuccess('Xóa voucher thành công');
    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_VOUCHERS_FROM_CAMPAIGN_FAILED,
    });
  }
}

// DELETE CAMPAIGN
function* deleteVoucherCampaign({ payload }) {
  const { id, callback } = payload;
  try {
    yield voucherCampaignApi.deleteCampaign(id);
    yield put({
      type: DELETE_VOUCHER_CAMPAIGN_SUCCESS,
    });
    showSuccess('Xóa chiến dịch voucher thành công');
    if (callback) callback();
  } catch (error) {
    apiErrorHandler(error);
    yield put({
      type: DELETE_VOUCHER_CAMPAIGN_FAILED,
    });
  }
}

export default function* voucherSaga() {
  yield takeLeading(GET_VOUCHER_LIST, getVoucherList);
  yield takeLeading(GET_VOUCHER_DETAIL, getVoucherDetail);
  yield takeLeading(CREATE_VOUCHER_CAMPAIGN, createVoucherCampaign);
  yield takeLeading(UPDATE_VOUCHER_CAMPAIGN, updateVoucherCampaign);
  yield takeLeading(ADD_CODE_TO_VOUCHER_CAMPAIGN, addCodeToVoucherCampaign);
  yield takeLeading(DELETE_VOUCHERS_FROM_CAMPAIGN, deleteVouchersFromCampaign);
  yield takeLeading(DELETE_VOUCHER_CAMPAIGN, deleteVoucherCampaign);
}
